import { combineReducers } from 'redux'
import { createReducer } from 'helpers/ReducerUtil'
import * as R from 'ramda'
import P from 'helpers/predicates'

import {
  INIT_REVISIONS,
  UPDATE_REVISIONS,
  UPDATE_CURRENT_REVISION,
  UPDATE_OLDEST_REVISION,
  UPDATE_LATEST_REVISION,
  UPDATE_ORIGINAL_REVISION,
  UPDATE_MODIFIED_REVISION,
} from './constants'

const initRevisionDefault = () => null
const initRevisionsDefault = () => ({})

const updateRevisionId = (prev, { revisionId }) => P.isNotNil(revisionId)
  ? revisionId
  : prev

const updateRevisionObject = (prevElements, { revisionId, elements }) => ({
  ...prevElements,
  [revisionId]: {
    ...elements
  }
})

const oldestRevision = createReducer(initRevisionDefault(), {
  [INIT_REVISIONS]: initRevisionDefault,
  [UPDATE_OLDEST_REVISION]: updateRevisionId
})

const latestRevision = createReducer(initRevisionDefault(), {
  [INIT_REVISIONS]: initRevisionDefault,
  [UPDATE_LATEST_REVISION]: updateRevisionId
})

const originalRevision = createReducer(initRevisionDefault(), {
  [INIT_REVISIONS]: initRevisionDefault,
  [UPDATE_ORIGINAL_REVISION]: updateRevisionId
})

const modifiedRevision = createReducer(initRevisionDefault(), {
  [INIT_REVISIONS]: initRevisionDefault,
  [UPDATE_MODIFIED_REVISION]: updateRevisionId
})

const revisions = createReducer(initRevisionsDefault(), {
  [INIT_REVISIONS]: initRevisionsDefault,
  [UPDATE_REVISIONS]: updateRevisionObject
})

export default combineReducers({
  oldestRevision,
  latestRevision,
  originalRevision,
  modifiedRevision,
  revisions,
})
